<template>
    <div class="home-box">
      <PageTitle :title="'Update Role'" class="py-5"></PageTitle>
      <v-row align="center">
        <v-overlay :value="loading" :opacity="1" :color="'#FFFFFF'">
          <v-progress-circular color="#FFB300" indeterminate size="64"></v-progress-circular>
        </v-overlay>
  
        <div class="col-md-12 home-tabs-body">
          <RoleEditForm></RoleEditForm>
        </div>
      </v-row>
    </div>
  </template>
  
  <script>
  import RoleEditForm from "@/components/roles/EditRole";
  import PageTitle from "@/components/shared/PageTitle";
  import { createNamespacedHelpers } from "vuex";
  const { mapGetters } = createNamespacedHelpers("auth");
  
  export default {
    name: "RoleEdit",
    components: {
      RoleEditForm,
      PageTitle,
    },
    data: function () {
      return {
        editMode: false,
        loading: false
      };
    },
    computed: {
      ...mapGetters({
        profile: "profile",
      }),
    },
    mounted() {
      this.$store.dispatch("auth/getProfile");
    },
  
    watch: {
    }
  };
  </script>